export class EmailLogService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async insertLog(emailLog) {
        const response = await this.apiService.post('emailLog', emailLog.getState());
        if (response.status === 200) {
            return true;
        }
    }
}
